import timediff from 'timediff';
import { ConferenceStatusUtils } from './conferenceStatusUtils';
let currentRefreshTick = 0;

function eventStartEndViewModel(event) {
  const s = new Date(Date.parse(event.start));
  const e = new Date(Date.parse(event.end));
  return {
    eventStartDate: s.toLocaleString('en-us', { dateStyle: 'long' }),
    eventEndDate: e.toLocaleString('en-us', { dateStyle: 'long' }),
    eventStartTime: s.toLocaleTimeString('en-us', {
      timeStyle: 'short',
    }),
    eventEndTime: e.toLocaleTimeString('en-us', {
      timeStyle: 'short',
    }),
  };
}
function conferenceStartEndViewModel(conference) {
  const s = new Date(Date.parse(conference.start));
  const e = new Date(Date.parse(conference.end));
  return {
    startTime: s.toLocaleTimeString('en-us', {
      hour: '2-digit',
      minute: '2-digit',
    }),
    endTime: e.toLocaleTimeString('en-us', {
      hour: '2-digit',
      minute: '2-digit',
    }),
    eventDay: s.toLocaleString('en-us', { weekday: 'long' }),
    eventDate: s.toLocaleString('en-us', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }),
    conferenceStartDate: s,
    conferenceEndDate: e,
  };
}

function eventDetailDatesViewModel(event) {
  const a = Array.from(
    event?.conferences
      ?.reduce((acc, c) => {
        const ldt = conferenceStartEndViewModel(c);
        if (!acc.has(ldt.eventDate)) {
          acc.set(ldt.eventDate, {
            eventDate: ldt.eventDate,
            eventDay: ldt.eventDay,
            conferences: [],
          });
        }
        acc.get(ldt.eventDate).conferences.push({
          ...c,
          startTime: ldt.startTime,
          endTime: ldt.endTime,
          conferenceStartDate: ldt.conferenceStartDate,
          conferenceEndDate: ldt.conferenceEndDate,
        });
        return acc;
      }, new Map())
      .values(),
  );
  // to sort conference based on start date time
  for (let event of a) {
    event.conferences.sort((conference1, conference2) => {
      if (conference1.conferenceStartDate > conference2.conferenceStartDate) {
        return 1;
      } else if (conference1.conferenceStartDate < conference2.conferenceStartDate) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  // to sort event based on start date
  return (
    a?.sort((event1, event2) =>
      new Date(event1?.eventDate) < new Date(event2?.eventDate) ? -1 : 1,
    ) ?? []
  );
}
function speakersViewModel(event) {
  let speakers = Array.from(
    event.conferences
      .flatMap((c) => (c.speakers ? c.speakers : []))
      .reduce((acc, s) => {
        acc.set(s.id, s);
        return acc;
      }, new Map())
      .values(),
  );
  if (!speakers.length) {
    speakers = event.speakers;
  }

  return speakers;
}
function eventDataViewModel(event, refresh = false) {
  if (refresh) currentRefreshTick = currentRefreshTick + 1;
  return {
    ...event,
    ...eventStartEndViewModel(event),
    eventDetailDates: event.conferences?.length ? eventDetailDatesViewModel(event) : [],
    speakers: event.conferences ? speakersViewModel(event) : [],
    refresh: refresh ? currentRefreshTick : 0,
  };
}

function conferenceStatus(conferenceStartTime, conferenceEndTime) {
  let status = '';
  const currentTime = new Date();
  const timeDiffStart = timediff(currentTime, conferenceStartTime, 'S');
  if (timeDiffStart.seconds <= 900 && timeDiffStart.seconds >= 0) {
    status = ConferenceStatusUtils.status.startingSoon;
  } else if (currentTime > conferenceStartTime && currentTime < conferenceEndTime) {
    status = ConferenceStatusUtils.status.ongoing;
  } else if (currentTime > conferenceEndTime) {
    status = ConferenceStatusUtils.status.finished;
  }

  return status;
}

function getFormattedTimeZone(timezone) {
  const timeZoneDict = {
    'Asia/Calcutta': 'Asia/Kolkata',
    'Pacific/Samoa': 'Pacific/Pago_Pago',
    'Etc/GMT-3': 'Europe/Istanbul',
  };

  return timeZoneDict[timezone] ?? timezone;
}

function eventDayDifference(eventStartDate) {
  return timediff(new Date(), eventStartDate, 'DHmS');
}

function isToday(someDate) {
  const today = new Date();
  return (
    someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
  );
}

export { eventDataViewModel, conferenceStatus, eventDayDifference, isToday, getFormattedTimeZone };
